import { Injectable } from '@angular/core';
import { IInterventionEntry } from '../../interfaces/intervention-entry-interface';
import { Observable } from 'rxjs';
import { IInterventionDbInterface } from '../../interfaces/intervention-db-interface';
import { InterventionDbRepositoryService } from '../../repositories/intervention_db_repository/intervention-db-repository.service';

@Injectable({
  providedIn: 'root'
})
export class InterventionDbService {

  constructor(private interventionRepository: InterventionDbRepositoryService) { }

  createIntervention(data: IInterventionEntry): Observable<any> {
    return this.interventionRepository.createIntervention(data);
  }

  getInteverventionsByCustomer(customer: string, fromDate?: Date, toDate?: Date, startKey?: string, take?: number) : Observable<IInterventionDbInterface[]>{
    return this.interventionRepository.getInterventions(
      fromDate,
      toDate,
      startKey,
      take,
      undefined,
      customer
    );
  }

  getInteverventionsByBugId(bugId: string, fromDate?: Date, toDate?: Date, startKey?: string, take?: number) : Observable<IInterventionDbInterface[]> {
    return this.interventionRepository.getInterventions(
      fromDate,
      toDate,
      startKey,
      take,
      bugId,
      undefined
    );
  }

  getAllInterventions(fromDate?: Date, toDate?: Date, startKey?: string, take?: number) {
    return this.interventionRepository.getInterventions(
      fromDate,
      toDate,
      startKey,
      take,
      undefined,
      undefined
    );
  }

}
